import { type InsuranceCorporateIdentity } from "../types";

export function AxaLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_3_1010)">
        <path
          d="M287.873 252.851H317.276L512 0H483.24L287.873 252.851Z"
          fill="#FF1721"
        />
        <path
          d="M391.219 365.686C400.143 390.654 418.532 455.627 425.843 460.803H377.566C377.421 455.059 376.661 449.347 375.3 443.764C373.218 436.338 355.756 380.159 355.756 380.159H279.072L267.015 397.251C267.015 397.251 281.496 442.582 282.396 444.805C283.957 448.809 290.872 460.803 290.872 460.803H244.606C244.606 460.803 243.406 453.88 242.956 450.996C242.594 448.668 238.573 435.915 238.573 435.915C238.573 435.915 228.087 447.406 225.229 452.734C222.345 458.051 221.066 460.803 221.066 460.803H184.872C184.872 460.803 183.663 453.88 183.213 450.996C182.861 448.668 178.433 434.892 178.433 434.892C178.433 434.892 168.3 447.195 165.416 452.513C162.55 457.84 161.315 460.803 161.315 460.803H125.518C125.518 460.803 135.633 451.172 139.17 447.036C145.131 440.025 167.348 410.992 167.348 410.992L158.44 380.159H82.3377C82.3377 380.159 38.9463 437.176 37.2359 438.94C35.5073 440.677 22.8603 458.828 22.5776 460.803H0V446.446C0.280031 446.141 0.57734 445.852 0.89046 445.581C1.58766 445.069 33.7869 405.1 63.3672 365.686C89.9491 331.317 114.89 297.891 117.077 294.708C122.378 287.009 130.015 270.385 130.015 270.385H169.358C169.358 270.385 170.575 285.677 171.722 289.39C172.745 292.671 196.716 371.322 197.28 372.169L210.536 355.218L187.879 285.474C187.879 285.474 182.57 272.351 180.841 270.385H226.799C226.637 274.603 227.143 278.821 228.298 282.881C230.168 288.632 240.02 324.182 240.02 324.182C240.02 324.182 271.364 284.892 273.198 282.07C275.424 278.55 276.754 274.538 277.069 270.385H315.363C315.363 270.385 308.352 275.508 296.066 291.048C291.939 296.278 251.502 347.669 251.502 347.669C251.502 347.669 255.03 359.698 256.75 365.686C257.217 367.406 257.543 368.57 257.543 368.694C257.543 368.747 258.434 367.653 259.968 365.686C270.402 352.466 317.859 290.237 320.734 284.909C323.054 280.606 326.466 275.711 328.469 270.385H365.827C365.827 270.385 366.692 281.541 367.829 284.628L391.219 365.686ZM334.369 306.782C328.883 318.582 296.595 357.89 296.595 357.89H347.73C347.73 357.89 337.818 327.366 336.089 320.487C335.206 316.088 334.868 311.598 335.083 307.117C335.083 306.491 334.968 305.477 334.369 306.782ZM137.899 306.782C132.414 318.582 100.126 357.89 100.126 357.89H151.261C151.261 357.89 141.357 327.366 139.629 320.487C138.745 316.088 138.408 311.598 138.623 307.117C138.623 306.491 138.5 305.477 137.899 306.782ZM214.884 425.967L228.96 406.635C227.663 405.241 219.735 381.2 219.735 381.2L206.126 398.856L214.884 425.967Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_1010">
          <rect width="512" height="512" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const Axa: InsuranceCorporateIdentity = {
  id: "axa",
  name: "Axa",
  logo: AxaLogo,
  backgroundColor: "#00008F",
  textColor: "#FFFFFF",
  wildcard: "axa",
  type: "private",
};
